"use strict";

import state from './state';
import mutations from './mutations';
import getters from './getters';

export default {

  state,
  mutations,
  getters

}



// WEBPACK FOOTER //
// ./src/store/modules/budget/main.js